import React,{useEffect} from 'react';
import {setearTotalUsuariosActivos} from '../../../reducer/users-reducers';
import { connect } from 'react-redux';

type configObject =  {
    usersReducer:{
        totalusuariosActivos: null | number
    }
}

const TotalUsers = ({setearTotalUsuariosActivos, totalusuariosActivos}:{ setearTotalUsuariosActivos: ()=> void, totalusuariosActivos:number | null}) => {

    useEffect(()=>{

        setearTotalUsuariosActivos();

    },[setearTotalUsuariosActivos])

    return (
        <div className='text-end'>
            {totalusuariosActivos && <p><strong>Total de usuarios activos:</strong> {totalusuariosActivos}</p>}
        </div>
    );
};


const mapStateToProps = (state: configObject) => {
    return {
        totalusuariosActivos: state.usersReducer.totalusuariosActivos,
    };
  };
  export default connect(mapStateToProps, {
    setearTotalUsuariosActivos,
  })(TotalUsers);
